import {
    INIT_OIL_BY_COMPANY_REQUEST,
    SET_OIL_BY_COMPANY,
    ERROR_OIL_BY_COMPANY
  } from './action';
  
  const initialState = {
    error: null,
    isLoading: false,
    oilByCompany: []
  };
  
  const oilListByCompanyReducer = (state = initialState, action) => {
    switch (action.type) {
      case INIT_OIL_BY_COMPANY_REQUEST:
        return {
          ...state,
          isLoading: true,
          error: null,
        };
  
      case SET_OIL_BY_COMPANY:
        return {
          ...state,
          oilByCompany: action.payload,
          isLoading: false,
          error: null,
        };
  
      case ERROR_OIL_BY_COMPANY:
        return {
          ...state,
          isLoading: false,
          oilByCompany: [],
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default oilListByCompanyReducer;
  